import { Redirect } from 'wouter';
import { useAuth } from '@/contexts/auth-context';
import { homePathForRole } from '@/contexts/role-home';

// /login and /register are for signed-out visitors: a signed-in user opening them goes to their home. While the
// session is still being checked the page renders as usual (no extra loading state for anonymous visitors), and
// login() keeps loading on until it has navigated, so this never races its own redirect.
export function GuestOnly({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (user && !loading) return <Redirect to={homePathForRole(user.role)} replace />;
  return <>{children}</>;
}
